export default __webpack_public_path__ + "static/media/Intake_Agreement_v1.2.5808c120.docx";